(() => {
  const root = document.querySelector('[data-mm-review-display]');
  if (!root) return;

  function updateEmptyState() {
    root.querySelectorAll('.jm-no-reviews-state').forEach(state => {
      const message = state.querySelector('.jm-no-reviews-state__text');
      if (message && message.textContent !== root.dataset.emptyMessage) {
        message.textContent = root.dataset.emptyMessage;
      }
      if (!state.querySelector('.mm-all-reviews-link')) {
        const link = document.createElement('a');
        link.className = 'mmh-review-link mm-all-reviews-link';
        link.href = root.dataset.allReviewsUrl;
        link.textContent = root.dataset.allReviewsLabel;
        state.append(link);
      }
    });
  }

  updateEmptyState();
  new MutationObserver(updateEmptyState).observe(root, {
    childList: true,
    characterData: true,
    subtree: true,
  });

  document.querySelectorAll('.mmp-review-link').forEach(link => {
    link.addEventListener('click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      root.scrollIntoView({ behavior: 'instant', block: 'start' });
      root.focus({ preventScroll: true });
      history.replaceState(null, '', link.getAttribute('href'));
    });
  });
})();
